import './styles.scss';

import React from 'react';
import UsersAlerts from "../../components/specific/Users.alerts/Users.alerts.component";
import useUserStore from "../../data/User.store";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";

function AlertsContainer() {
    const {user, loadingUser} = useUserStore();

    if (loadingUser || !user) {
        return (
            <div className='default-loader-full'>
                <DefaultLoader text='Loading user...'/>
            </div>
        )
    }

    return (
        <div className='alerts-container'>
            <UsersAlerts userId={`${user.id}`}/>
        </div>
    )
}

export default AlertsContainer;